module.exports = __webpack_public_path__ + "static/img/Bachelor_010327.a841859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010327.jpg
// module id = 149
// module chunks = 0